// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* components/BgAnimation.module.css */

.BgAnimation_bgAnimationContainer__nWfKY {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
}

.BgAnimation_particleCanvas__V\\+3mc {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  z-index: 1;
}

/* Grid Lines */
.BgAnimation_gridLines__1XxoW {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(77, 107, 223, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(77, 107, 223, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  z-index: 2;
  pointer-events: none;
  animation: BgAnimation_gridFloat__IXGch 20s linear infinite;
}

@keyframes BgAnimation_gridFloat__IXGch {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(50px);
  }
}

/* Floating Orbs */
.BgAnimation_floatingOrb__D-\\+EZ {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.3;
  z-index: 0;
  pointer-events: none;
  animation: BgAnimation_floatOrb__8lwQ5 15s ease-in-out infinite;
}

.BgAnimation_floatingOrb__D-\\+EZ:nth-child(1) {
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(77, 107, 223, 0.4), rgba(77, 107, 223, 0));
  top: -150px;
  left: -150px;
  animation-delay: 0s;
}

.BgAnimation_floatingOrb__D-\\+EZ:nth-child(2) {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(163, 112, 206, 0.3), rgba(163, 112, 206, 0));
  bottom: -200px;
  right: -200px;
  animation-delay: 5s;
  animation-duration: 20s;
}

.BgAnimation_floatingOrb__D-\\+EZ:nth-child(3) {
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, rgba(77, 107, 223, 0.35), rgba(77, 107, 223, 0));
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation-delay: 10s;
  animation-duration: 18s;
}

@keyframes BgAnimation_floatOrb__8lwQ5 {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(50px, 50px) scale(1.1);
  }
  66% {
    transform: translate(-30px, 40px) scale(0.95);
  }
}

/* Gradient Border */
.BgAnimation_gradientBorder__eKnk9 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 3;
  pointer-events: none;
  border: 1px solid transparent;
  animation: BgAnimation_borderPulse__5d2Az 3s ease-in-out infinite;
}

@keyframes BgAnimation_borderPulse__5d2Az {
  0%, 100% {
    border-color: rgba(77, 107, 223, 0.05);
  }
  50% {
    border-color: rgba(163, 112, 206, 0.15);
  }
}

/* Glitch Overlay */
.BgAnimation_glitchOverlay__eqD1E {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: repeating-linear-gradient(
    0deg,
    rgba(77, 107, 223, 0.02) 0px,
    rgba(77, 107, 223, 0.02) 1px,
    transparent 1px,
    transparent 2px
  );
  z-index: 4;
  pointer-events: none;
  opacity: 0.5;
  animation: BgAnimation_glitchShift__RXZG6 8s linear infinite;
}

@keyframes BgAnimation_glitchShift__RXZG6 {
  0%, 100% {
    transform: translateY(0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translateY(1px);
  }
  20%, 40%, 60%, 80% {
    transform: translateY(-1px);
  }
}

/* Animated Lines */
.BgAnimation_animatedLines__Ch3jM {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  pointer-events: none;
  opacity: 0.6;
}

.BgAnimation_animatedLines__Ch3jM svg {
  width: 100%;
  height: 100%;
}

/* Mouse Follower - Optional, can be removed or kept as decorative */
.BgAnimation_mouseFollower__FrUiQ {
  position: fixed;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(77, 107, 223, 0.08), transparent);
  pointer-events: none;
  z-index: 6;
  transform: translate(-50%, -50%);
  transition: transform 0.05s linear;
  opacity: 0;
  animation: BgAnimation_fadeInFollower__pBzqs 2s ease-in forwards;
}

@keyframes BgAnimation_fadeInFollower__pBzqs {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .BgAnimation_floatingOrb__D-\\+EZ:nth-child(1) {
    width: 200px;
    height: 200px;
  }
  
  .BgAnimation_floatingOrb__D-\\+EZ:nth-child(2) {
    width: 250px;
    height: 250px;
  }
  
  .BgAnimation_floatingOrb__D-\\+EZ:nth-child(3) {
    width: 150px;
    height: 150px;
  }
  
  .BgAnimation_gridLines__1XxoW {
    background-size: 30px 30px;
  }
}

/* Optional: Add a subtle vignette effect */
.BgAnimation_bgAnimationContainer__nWfKY::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at center, transparent 50%, rgba(0, 0, 0, 0.3) 100%);
  pointer-events: none;
  z-index: 7;
}

/* Optional: Scanning line effect */
.BgAnimation_bgAnimationContainer__nWfKY::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(77, 107, 223, 0.05),
    transparent
  );
  animation: BgAnimation_scan__FFVVv 8s linear infinite;
  pointer-events: none;
  z-index: 8;
}

@keyframes BgAnimation_scan__FFVVv {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

/* Performance optimization for animations */
@media (prefers-reduced-motion: reduce) {
  .BgAnimation_floatingOrb__D-\\+EZ,
  .BgAnimation_gridLines__1XxoW,
  .BgAnimation_gradientBorder__eKnk9,
  .BgAnimation_glitchOverlay__eqD1E,
  .BgAnimation_animatedLines__Ch3jM line {
    animation: none;
  }
  
  .BgAnimation_bgAnimationContainer__nWfKY::before {
    animation: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Component/Animation/BgAnimation.module.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;yEAEuE;EACvE,0BAA0B;EAC1B,UAAU;EACV,oBAAoB;EACpB,2DAAwC;AAC1C;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,+DAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mFAAmF;EACnF,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qFAAqF;EACrF,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oFAAoF;EACpF,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE;IACE,mCAAmC;EACrC;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,oBAAoB;EACpB,6BAA6B;EAC7B,iEAA8C;AAChD;;AAEA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,uCAAuC;EACzC;AACF;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;;GAMC;EACD,UAAU;EACV,oBAAoB;EACpB,YAAY;EACZ,4DAAyC;AAC3C;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oEAAoE;AACpE;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0EAA0E;EAC1E,oBAAoB;EACpB,UAAU;EACV,gCAAgC;EAChC,kCAAkC;EAClC,UAAU;EACV,gEAA6C;AAC/C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uFAAuF;EACvF,oBAAoB;EACpB,UAAU;AACZ;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,qDAAkC;EAClC,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,4CAA4C;AAC5C;EACE;;;;;IAKE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* components/BgAnimation.module.css */\n\n.bgAnimationContainer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.particleCanvas {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n  z-index: 1;\n}\n\n/* Grid Lines */\n.gridLines {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-image: \n    linear-gradient(rgba(77, 107, 223, 0.03) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(77, 107, 223, 0.03) 1px, transparent 1px);\n  background-size: 50px 50px;\n  z-index: 2;\n  pointer-events: none;\n  animation: gridFloat 20s linear infinite;\n}\n\n@keyframes gridFloat {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(50px);\n  }\n}\n\n/* Floating Orbs */\n.floatingOrb {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(60px);\n  opacity: 0.3;\n  z-index: 0;\n  pointer-events: none;\n  animation: floatOrb 15s ease-in-out infinite;\n}\n\n.floatingOrb:nth-child(1) {\n  width: 300px;\n  height: 300px;\n  background: radial-gradient(circle, rgba(77, 107, 223, 0.4), rgba(77, 107, 223, 0));\n  top: -150px;\n  left: -150px;\n  animation-delay: 0s;\n}\n\n.floatingOrb:nth-child(2) {\n  width: 400px;\n  height: 400px;\n  background: radial-gradient(circle, rgba(163, 112, 206, 0.3), rgba(163, 112, 206, 0));\n  bottom: -200px;\n  right: -200px;\n  animation-delay: 5s;\n  animation-duration: 20s;\n}\n\n.floatingOrb:nth-child(3) {\n  width: 250px;\n  height: 250px;\n  background: radial-gradient(circle, rgba(77, 107, 223, 0.35), rgba(77, 107, 223, 0));\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  animation-delay: 10s;\n  animation-duration: 18s;\n}\n\n@keyframes floatOrb {\n  0%, 100% {\n    transform: translate(0, 0) scale(1);\n  }\n  33% {\n    transform: translate(50px, 50px) scale(1.1);\n  }\n  66% {\n    transform: translate(-30px, 40px) scale(0.95);\n  }\n}\n\n/* Gradient Border */\n.gradientBorder {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: transparent;\n  z-index: 3;\n  pointer-events: none;\n  border: 1px solid transparent;\n  animation: borderPulse 3s ease-in-out infinite;\n}\n\n@keyframes borderPulse {\n  0%, 100% {\n    border-color: rgba(77, 107, 223, 0.05);\n  }\n  50% {\n    border-color: rgba(163, 112, 206, 0.15);\n  }\n}\n\n/* Glitch Overlay */\n.glitchOverlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: repeating-linear-gradient(\n    0deg,\n    rgba(77, 107, 223, 0.02) 0px,\n    rgba(77, 107, 223, 0.02) 1px,\n    transparent 1px,\n    transparent 2px\n  );\n  z-index: 4;\n  pointer-events: none;\n  opacity: 0.5;\n  animation: glitchShift 8s linear infinite;\n}\n\n@keyframes glitchShift {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  10%, 30%, 50%, 70%, 90% {\n    transform: translateY(1px);\n  }\n  20%, 40%, 60%, 80% {\n    transform: translateY(-1px);\n  }\n}\n\n/* Animated Lines */\n.animatedLines {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 5;\n  pointer-events: none;\n  opacity: 0.6;\n}\n\n.animatedLines svg {\n  width: 100%;\n  height: 100%;\n}\n\n/* Mouse Follower - Optional, can be removed or kept as decorative */\n.mouseFollower {\n  position: fixed;\n  width: 200px;\n  height: 200px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(77, 107, 223, 0.08), transparent);\n  pointer-events: none;\n  z-index: 6;\n  transform: translate(-50%, -50%);\n  transition: transform 0.05s linear;\n  opacity: 0;\n  animation: fadeInFollower 2s ease-in forwards;\n}\n\n@keyframes fadeInFollower {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .floatingOrb:nth-child(1) {\n    width: 200px;\n    height: 200px;\n  }\n  \n  .floatingOrb:nth-child(2) {\n    width: 250px;\n    height: 250px;\n  }\n  \n  .floatingOrb:nth-child(3) {\n    width: 150px;\n    height: 150px;\n  }\n  \n  .gridLines {\n    background-size: 30px 30px;\n  }\n}\n\n/* Optional: Add a subtle vignette effect */\n.bgAnimationContainer::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: radial-gradient(circle at center, transparent 50%, rgba(0, 0, 0, 0.3) 100%);\n  pointer-events: none;\n  z-index: 7;\n}\n\n/* Optional: Scanning line effect */\n.bgAnimationContainer::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(77, 107, 223, 0.05),\n    transparent\n  );\n  animation: scan 8s linear infinite;\n  pointer-events: none;\n  z-index: 8;\n}\n\n@keyframes scan {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n/* Performance optimization for animations */\n@media (prefers-reduced-motion: reduce) {\n  .floatingOrb,\n  .gridLines,\n  .gradientBorder,\n  .glitchOverlay,\n  .animatedLines line {\n    animation: none;\n  }\n  \n  .bgAnimationContainer::before {\n    animation: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bgAnimationContainer": `BgAnimation_bgAnimationContainer__nWfKY`,
	"particleCanvas": `BgAnimation_particleCanvas__V+3mc`,
	"gridLines": `BgAnimation_gridLines__1XxoW`,
	"gridFloat": `BgAnimation_gridFloat__IXGch`,
	"floatingOrb": `BgAnimation_floatingOrb__D-+EZ`,
	"floatOrb": `BgAnimation_floatOrb__8lwQ5`,
	"gradientBorder": `BgAnimation_gradientBorder__eKnk9`,
	"borderPulse": `BgAnimation_borderPulse__5d2Az`,
	"glitchOverlay": `BgAnimation_glitchOverlay__eqD1E`,
	"glitchShift": `BgAnimation_glitchShift__RXZG6`,
	"animatedLines": `BgAnimation_animatedLines__Ch3jM`,
	"mouseFollower": `BgAnimation_mouseFollower__FrUiQ`,
	"fadeInFollower": `BgAnimation_fadeInFollower__pBzqs`,
	"scan": `BgAnimation_scan__FFVVv`
};
export default ___CSS_LOADER_EXPORT___;
